import React, { useEffect, useState } from "react";
import { ConnectedProps, connect, useSelector } from "react-redux";
import { AppDispatch, RootState } from "store";
import { Polygons } from "./Polygons";
import { TabType } from "component/TabControler/types";
import { PolygonsContainerProps, PolygonsTabsType } from "./types";
import { actions, regionSelector } from "reducers/regions";
import { sessionSelector } from "reducers/session";
import { actions as notificationActions } from "reducers/notification";
import { NotificationStateType } from "reducers/types/notification";
import { ReactComponent as General } from "assets/general.svg";
import { ReactComponent as Pricing } from "assets/pricing.svg";
import "./i18n";
import { dirtyAlert } from "utils/alerts";
import { useHistory, useLocation } from "react-router-dom";
import { parseQueryParams } from "utils/utils";

const tabs: TabType<PolygonsTabsType>[] = [
  {
    title: "polygon:general",
    id: "general",
    icon: General,
    testId: "polygons-tab-general",
    name: "general",
  },
  {
    title: "polygon:pricing",
    id: "pricing",
    icon: Pricing,
    testId: "polygons-tab-pricing",
    name: "pricing",
  },
];

const PolygonsContainer = (
  props: PolygonsContainerProps & ConnectorProps
): JSX.Element => {
  const { countryCode } = useSelector(sessionSelector);
  const history = useHistory();
  const location = useLocation();
  const [shouldRenderTabContent, setShouldRenderTabContent] = useState(false);

  const queryParams = parseQueryParams(location.search);
  const tabFromUrl = queryParams.tab as PolygonsTabsType;

  const changePage = (page: PolygonsTabsType) => {
    const callback = () => {
      props.setActualPage(page);
      history.replace(`/${countryCode}/polygons?tab=${page}`);
    };
    if (props.dirty) props.showNotification(dirtyAlert({ onCancel: callback }));
    else callback();
  };

  useEffect(() => {
    if (!tabFromUrl || (tabFromUrl !== "general" && tabFromUrl !== "pricing")) {
      props.setActualPage("general");
      history.replace(`/${countryCode}/polygons?tab=general`);
    } else {
      props.setActualPage(tabFromUrl);
    }
    setShouldRenderTabContent(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countryCode]);

  return shouldRenderTabContent ? (
    <Polygons
      {...props}
      tabs={tabs}
      changePage={changePage}
      testId="polygons"
    />
  ) : (
    <></>
  );
};

const mapStateToProps = (state: RootState) => ({
  actualPage: regionSelector(state).actualPage,
  dirty: sessionSelector(state).dirtyForm,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  setActualPage: (page: PolygonsTabsType) => {
    dispatch(actions.setActualPage(page));
  },
  showNotification: (content: NotificationStateType) => {
    dispatch(notificationActions.showNotification(content));
  },
});

const connector = connect(mapStateToProps, mapDispatchToProps);

type ConnectorProps = ConnectedProps<typeof connector>;

export default connector(PolygonsContainer);
